import { render, staticRenderFns } from "./JTMSPayments.vue?vue&type=template&id=d11ae832&scoped=true&"
import script from "./JTMSPayments.vue?vue&type=script&lang=ts&"
export * from "./JTMSPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11ae832",
  null
  
)

export default component.exports